
import { useState, useCallback } from "react";
import { AuthState } from "@/lib/types/auth";
import { User } from "@supabase/supabase-js";
import { fetchProfile } from "../utils/profile";

export const useAuthState = () => {
  const [state, setState] = useState<AuthState>({
    user: null,
    profile: null,
    isLoading: true,
  });

  const debouncedSetState = useCallback((newState: Partial<AuthState>) => {
    setState(prev => ({
      ...prev,
      ...newState,
    }));
  }, []);

  const updateAuthState = useCallback(async (user: User | null, skipProfileFetch = false) => {
    console.log("Updating auth state for user:", user?.id);
    
    // Immediately update user and loading state
    debouncedSetState({
      user,
      isLoading: false
    });

    // Then fetch profile if needed
    if (user && !skipProfileFetch) {
      try {
        const profile = await fetchProfile(user.id);
        debouncedSetState({
          profile,
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
        // Don't update loading state here as it's already false
      }
    } else {
      debouncedSetState({
        profile: null,
      });
    }
  }, [debouncedSetState]);

  return {
    state,
    debouncedSetState,
    updateAuthState,
  };
};
